import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();

const APP_BUILD_ENV = publicRuntimeConfig.APP_BUILD_ENV;

const config = {
  qa: {
    DOMAIN_HOST: "https://tools.hellopye.com",
    PRODUCT_DOMAIN_HOST: "https://wazirx.hellopye.com",
    API_HOST: "https://api.hellopye.com",
    SENTRY_DSN:
      "https://ede2f0ea76f84a41aea0813c059f8852@o524464.ingest.sentry.io/5852364",
    GA_TRACKING_KEY: "GTM-5G936K9",
  },
  prod: {
    DOMAIN_HOST: "https://tools.wazirx.com",
    PRODUCT_DOMAIN_HOST: "https://wazirx.com",
    API_HOST: "https://x.wazirx.com",
    SENTRY_DSN:
      "https://ede2f0ea76f84a41aea0813c059f8852@o524464.ingest.sentry.io/5852364",
    GA_TRACKING_KEY: "GTM-5G936K9",
  },
};

export default config[APP_BUILD_ENV];
